import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
// import { createTheme } from '@material-ui/core/styles';

import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
// import red from '@material-ui/core/colors/red';
// import green from "@material-ui/core/colors/green";
// import teal from "@material-ui/core/colors/teal";

const theme = createTheme({
  palette: {
    type: "dark",
    background: {
      default: "#111111",
    },
    primary: {
      light: "#00D253",
      main: "#00D253",
      dark: "#00D253",
      background: "red",
      contrastText: "#fff",
    },
    secondary: {
      light: "#123649",
      main: "#11111",
      dark: "red",
      contrastText: "#FFF",
    },
  },
});

// Color Setup
// https://material-ui.com/customization/color/#playground

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
    {/* <App /> */}
  </React.StrictMode>,
  document.getElementById("root")
);
